import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { styles } from './home-page-styles';
import { getCurrentSystemInfo } from 'src/xlr-configuration/xlr-config';

const NTEPCertification: React.FC<NTEPCertificationProps> = (props): JSX.Element => {
  const systemInfo = getCurrentSystemInfo();
  const classes = styles();

  return (
    <Grid container data-testid='ntep-certification'>
      <Typography variant='body2'>
        <span className={props.className == null ? classes.ntep : props.className}>
          {systemInfo}
        </span>
      </Typography>
    </Grid>
  );
};

interface NTEPCertificationProps {
  className?: string;
}

export default NTEPCertification;
